import { BillingApi, Configuration } from '@/api';
import { invoicesQueryKey } from '@/api/queries/useFindInvoicesQuery';
import { getInvoiceQueryKey } from '@/api/queries/useGetInvoiceQuery';
import { useAuth } from '@/modules/auth/contexts/AuthContext';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export default function useProcessInvoiceTransactionsMutation() {
  const queryClient = useQueryClient();
  const auth = useAuth();
  const api = new BillingApi(new Configuration(auth));

  return useMutation({
    mutationFn: async () => {
      return api.processInvoiceTransactions();
    },
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          predicate: (query) => query.queryKey[0] === invoicesQueryKey[0],
        }),
        queryClient.invalidateQueries({
          predicate: (query) => query.queryKey[0] === getInvoiceQueryKey()[0],
        }),
      ]);
    },
  });
}
